import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "Regions" }
const _hoisted_2 = { class: "flex itemscenter justify-between mt-6" }
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-gray-400 mt-3"
}
const _hoisted_4 = { class: "flex items-center justify-end mt-3" }
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_regions_actions = _resolveComponent("regions-actions")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_regions_actions, {
          key: 0,
          loading: _ctx.actions_state.is_actions_loading,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "is-delete": _ctx.actions_state.is_delete,
          "initial-value": _ctx.actions_state.initial_value,
          onCreate: _ctx.createRegion,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
          onUpdate: _ctx.updateRegion,
          onDelete: _ctx.deleteRegion
        }, null, 8, ["loading", "is-create", "is-update", "is-delete", "initial-value", "onCreate", "onUpdate", "onDelete"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_page_title, { title: "Регионы" }),
        _createVNode(_component_the_button, {
          class: "primary small",
          onClick: _ctx.startCreate
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Добавить регион ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("form", {
        class: "flex flex-col px-6 py-4 border bg-white mt-6",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.searchRegion && _ctx.searchRegion(...args)), ["prevent"]))
      }, [
        _createVNode(_component_the_input, {
          placeholder: "Поиск по названию региона",
          value: _ctx.filters_state.search_query,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.search_query) = $event)),
          class: "w-full"
        }, null, 8, ["value"]),
        (_ctx.regions_copy.is_search)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Найдено: " + _toDisplayString(_ctx.state.list.length), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_the_button, {
            class: "second text small mr-3",
            loading: _ctx.regions_copy.is_search,
            onClick: _ctx.resetFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Сбросить ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]),
          _createVNode(_component_the_button, {
            class: "primary text small w-fit",
            loading: _ctx.regions_copy.is_search,
            type: "submit"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Поиск ")
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ], 32),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 0,
              loading: _ctx.state.is_loading,
              text: "При получении списка регионов произошла ошибка",
              "error-message": _ctx.state.failure.error_state.message,
              "error-url": _ctx.state.failure.error_state.url,
              "error-status": _ctx.state.failure.error_state.status,
              onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadRegions(_ctx.state.pagination.current_page)))
            }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
          : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
              key: 1,
              loading: _ctx.state.is_loading
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_table, {
                  loading: _ctx.state.is_loading,
                  columns: _ctx.RegionsColumns,
                  rows: _ctx.state.list,
                  "with-limit": "",
                  "pagination-limit": _ctx.filters_state.limit,
                  "pagination-total-items": _ctx.state.pagination.total_items,
                  "pagination-current-page": _ctx.state.pagination.current_page,
                  "pagination-total-pages": _ctx.state.pagination.total_pages,
                  onChangePage: _ctx.loadRegions,
                  onChangeLimit: _ctx.onLimitChange
                }, {
                  actions: _withCtx(({ row }) => [
                    _createVNode(_component_the_button, {
                      hint: "Редактировать",
                      class: "yellow extra-small mr-3",
                      onClick: ($event: any) => (_ctx.startUpdate(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_the_button, {
                      class: "extra-small red",
                      hint: "Удалить",
                      loading: _ctx.state.is_loading,
                      onClick: ($event: any) => (_ctx.startDelete(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 2
                    }, 1032, ["loading", "onClick"])
                  ]),
                  _: 1
                }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
              ]),
              _: 1
            }, 8, ["loading"]))
      ])
    ])
  ], 64))
}